import GenericStore from '../classes/generic-store';
import { ContactModel } from '../models/contact';
import { removeContactFromAccount } from '../api/accounts-legacy-api';
import { getContact } from '../api/contacts-api';
import { UserApi } from '../api/generated/user-api';

class ContactStoreClass extends GenericStore {
  load(id) {
    return this.setState(getContact(id));
  }

  changeUserStatus(contactId, userId, isActive) {
    return this.watchState(
      UserApi.updateUser({ id: userId, body: { isActive } })
    ).then(() => {
      return this.load(contactId);
    });
  }

  removeContactFromAccount(contactId, accountId) {
    return removeContactFromAccount({ accountId, contactId }).then(() => {
      this.load(contactId);
    });
  }

  getDataShape() {
    return ContactModel;
  }
}

export const ContactStore = new ContactStoreClass();
